//
//
export const watch = {
  file() {
    this.updatePictures()
  }
}
